import $ from 'jquery';
import { MQ } from '../tools/MQ';

export const init = ($target) => {

	$(window).on('resize.search', function () {
		var $inp = $('.f-search .inp-text');

		if ( MQ('xlUp') || (MQ('smUp') && MQ('mdDown')) ) {
			$inp.attr('placeholder', $inp.data('placeholder'));
		}
		else {
			$inp.attr('placeholder', $inp.data('placeholder-sm'));
		}
	});

	$(window).trigger('resize.search');

};
